var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"text-center",attrs:{"label":"","x-small":"","color":_vm.color}},[_vm._v(" "+_vm._s(_vm.getSituacao(_vm.situacao))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }